import type { SandboxRunStatus } from '../../lib/api-client';

const STATUS_COLORS: Record<SandboxRunStatus, string> = {
  running: 'var(--accent)',
  completed: 'var(--kind-success, #2da44e)',
  error: 'var(--kind-failure, #cf222e)',
  incomplete: 'var(--warning, #c98a2b)',
};

export function RunStatusBadge({ status }: { status: SandboxRunStatus }) {
  const c = STATUS_COLORS[status];
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '1px 7px',
        fontSize: 10,
        fontWeight: 600,
        color: c,
        border: `1px solid ${c}`,
        borderRadius: 4,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
        fontFamily: 'inherit',
      }}
    >
      {status}
    </span>
  );
}
